// extracted by mini-css-extract-plugin
module.exports =  {"rect":"TextWithBg-module__rect--ORlEE","text":"TextWithBg-module__text--ebSI0","groupSelected":"TextWithBg-module__groupSelected--sW9fR"};